import React, {FC} from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export interface TextModalProps {
    readonly onClose: () => void;

    readonly isOpen: boolean;

    readonly heading: string;

    readonly text: string;
}

const BottomTextModal: FC<TextModalProps> = ({onClose, isOpen, heading, text}) => (
    <RsnDialog.Controller isOpen={isOpen} onClose={onClose}>
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader text={heading} />
            <RsnDialog.Body>
                <p>{text}</p>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Secondary type='button' onClick={onClose}>
                    I got it
                </RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    </RsnDialog.Controller>
);

export default BottomTextModal;
